// HOME FOLLOWS PATRICIA (Freddi, 2026-10-11: "the customer stays card needs to
// be constantly fetching updates as Patricia might be accepting bookings/deposits
// regularly … if we fetch and there's nothing to fetch nothing should change for
// the user but when it does change it should be seamless").
//
// A read every LIVE_REFRESH_MS while the page is visible; one at once when it
// comes back into view or the window regains focus — the phone pulled out of a
// pocket is the moment they look; none at all while hidden. The caller hands
// each read through `keepIfSame`, so an unchanged read returns the very object
// already on screen and React has nothing to redraw.

export const LIVE_REFRESH_MS = 15_000;

export function startLiveRefresh({ refresh, doc = document, win = window, everyMs = LIVE_REFRESH_MS }: {
  refresh: () => void;
  doc?: Document;
  win?: Window;
  everyMs?: number;
}): () => void {
  const tick = () => { if (!doc.hidden) refresh(); };
  const timer = setInterval(tick, everyMs);
  const onVisible = () => { if (!doc.hidden) refresh(); };
  doc.addEventListener('visibilitychange', onVisible);
  win.addEventListener('focus', onVisible);
  return () => {
    clearInterval(timer);
    doc.removeEventListener('visibilitychange', onVisible);
    win.removeEventListener('focus', onVisible);
  };
}

/**
 * ONLY THE NEWEST READ MAY LAND (PR #255 review, #63). Focus, visibility and
 * the timer can start reads that overlap; if an older one finishes last, its
 * snapshot would overwrite a newer one. Each read takes a number; a write that
 * changes the screen optimistically takes one too, so no read already in
 * flight can undo it.
 */
export function latestOnly(): { begin: () => number; isLatest: (n: number) => boolean } {
  let latest = 0;
  return { begin: () => ++latest, isLatest: (n) => n === latest };
}

/** The previous object when the read says the same thing — so nothing re-renders — else the new one. */
export function keepIfSame<T>(prev: T | null, next: T): T {
  if (prev !== null && JSON.stringify(prev) === JSON.stringify(next)) return prev;
  return next;
}
